<template>
  <div>
    <div class="top">
      <a href="#/ApprovalIndex">
        <img
          src="../assets/images/adidas.png"
          style="width: 160px; height: 37px; margin-top: 10px"
      /></a>
      <a
        href="#/ApprovalIndex"
        style="margin-top: 10px; margin-left: 30px; float: left"
      >
        <img src="../assets/icon/back2.png"
      /></a>
    </div>
    <div style="text-align: left">
      <el-input
        v-model="search_input"
        placeholder="Search by Project Code or POS Name"
        class="input-search"
      ></el-input>
      <el-button class="button-search" @click="BindData(1)">Search</el-button>
      <el-button class="button-search" @click="Approve()">Approve</el-button>
    </div>
    <div class="content_title">
      <div class="div-pagination">
        <el-pagination
          background
          @current-change="pagingChange"
          :current-page="currentPage"
          :page-size="10"
          layout="total, prev, pager, next, jumper"
          :total="total"
          ref="multipleTable"
        ></el-pagination>
      </div>
      <div>
        <el-table
          ref="multipleTable"
          v-loading="loading"
          @current-change="handleCurrentChange"
          :data="tableData"
          :header-cell-style="tableHeaderCell"
          :cell-style="tableCell"
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="60px" />
          <el-table-column label="Project Code/POS Code" min-width="160px">
            <template slot-scope="scope">
              <el-button
                type="text"
                style="padding: 0px; text-decoration: underline"
                size="small"
                @click="Closure(scope.row.projectID)"
                v-if="scope.row.type == 'Closure'"
                >{{ scope.row.projectcode }}</el-button
              >
              <el-button
                type="text"
                style="padding: 0px; text-decoration: underline"
                size="small"
                @click="Detail(scope.row.projectID)"
                v-if="!(scope.row.type == 'Closure')"
                >{{ scope.row.projectcode }}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="nameEN"
            label="POS Name"
            min-width="220px"
          ></el-table-column>
          <el-table-column
            prop="customername"
            label="Customer"
          ></el-table-column>
          <el-table-column prop="appDate" label="Apply Date"></el-table-column>
          <el-table-column prop="type" label="Type"></el-table-column>
        </el-table>
      </div>
      <div style="height: 20px"></div>
    </div>
  </div>
</template>

<script>
import {encryption} from '@/utils/secret.js'
export default {
  data() {
    return {
      total: 0,
      loading: true,
      tableData: [],
      search_input: "",
      multipleSelection: [],
      currentPage: 1,
    };
  },
  methods: {
    tableHeaderCell() {
      return "background: #FFEDD1;color: #5A5854;text-align: center;";
    },
    tableCell() {
      return "background: #FFFFFF;color: #5A5854;text-align: center;";
    },
    pagingChange(pageIndex) {
      this.BindData(pageIndex);
    },
    handleCurrentChange(row) {
      this.currentRow = row;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    BindData(pageIndex) {
      this.$api
        .get(
          "/List/GetPendingProjectInfo/",
          { pageIndex: pageIndex, search: this.search_input },
          (res) => {}
        )
        .then((res) => {
          this.currentPage = pageIndex;
          if (res.data.status == true) {
            this.tableData = res.data.content.list;
            this.total = res.data.content.total;
            this.loading = false;
          } else {
            if (res.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res.data.message,
              });
              return false;
            }
          }
        });
    },
    Approve() {
      let approvalID = [];
      for (let i = 0; i < this.multipleSelection.length; i++) {
        approvalID[i] = this.multipleSelection[i].projectID;
      }
      this.$api
        .post("Project/BatchApproveProject", {
          projectID: approvalID,
          operate: 1,
          comment: "",
        })
        .then((res2) => {
          if (res2.data.status == true) {
            this.openAlert(1);
          } else {
            if (res2.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res2.data.message,
              });
              return false;
            }
          }
        });
      this.BindData(1);
    },
    // 审批成功弹窗
    openAlert(operate) {
      let alertmsg = "Successfully Rejected!";
      if (operate == 1) {
        alertmsg = "Successfully Approved!";
      }
      this.$alert(alertmsg, {
        confirmButtonText: "确定",
        callback: () => {},
      });
    },
    Detail(projectID) {
      // this.$router.push({
      //   name: "Project",
      //   params: { ID: projectID, isapprove: true },
      // });
       this.$router.push({
        path: "/Project",
        query: { ID: encryption(projectID), isapprove: encryption('true') },
      });
    },
    Closure(projectID) {
      this.$router.push({
        name: "Closure",
        params: { ID: projectID, isapprove: true },
      });
    },
  },
  mounted() {
    this.BindData(1);
  },
};
</script>
<style scoped>
.el-table ::v-deep .cell,
.el-table ::v-deep th {
  padding-left: 10px;
}
.content_title {
  margin: auto;
  width: 90%;
  text-align: center;
}
.el-button--text {
  color: #606266;
}
.input-search {
  margin-top: 10px;
  margin-left: 5%;
  margin-right: 10px;
  width: 500px;
  text-align: left;
}
.button-search {
  background-color: #e6a23c;
  border: 0px #e6a23c;
  color: #ffff;
}
.div-pagination {
  text-align: right;
  margin-bottom: 10px;
}
.top {
  height: 60px;
  background: #232b33;
  color: white;
  text-align: center;
  line-height: 50px;
}
</style>
<style>
.el-table .cell,
.el-table th {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.el-table .cell,
.el-table--border td:first-child .cell,
.el-table--border th:first-child .cell {
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/List.vue